import { EPage } from '@sifrovacihra/shared-ui'
export { hash, notEmptyString, isValidPhone, isValidEmail, isValidFullName, isValidPlayer } from '@sifrovacihra/shared-ui'

export const changePage = (page: EPage, navigate: any) => {
    console.log(page)
    navigate('/' + page)
}

export function gameIdByYear(year: string): string {
    switch (year) {
        case '2021': return 'SIF2021'
        case '2022': return 'SIF2022'
        case '2023': return 'SIF2023'
        case '2024Z':
        case '2024P': return 'SIF2024'
        case '2025Z':
        case '2025P': return 'SIF2025'
        case '2026Z':
        case '2026P': return 'SIF2026'
    }
    return ''
}

export function gameCathegoryByYear(year: string): string | undefined {
    if (year.endsWith('Z')) return 'Z'
    if (year.endsWith('P')) return 'P'
    return undefined
}
